import { Phone, MessageSquareText } from "lucide-react";
import { SMS_HREF, TEL_HREF } from "@/lib/site";

export default function StickyMobileCTA() {
    return (
        <div
            className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-white/10 bg-black/95 backdrop-blur-xl"
            data-testid="sticky-mobile-cta"
        >
            <div className="grid grid-cols-2 gap-2 p-3">
                <a
                    href={SMS_HREF}
                    data-testid="sticky-text-now-button"
                    className="inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 active:scale-[0.98] transition-all text-white px-4 py-3.5 rounded-sm font-display font-bold uppercase tracking-wide text-sm"
                >
                    <MessageSquareText className="w-4 h-4" />
                    Text Now
                </a>
                <a
                    href={TEL_HREF}
                    data-testid="sticky-call-now-button"
                    className="inline-flex items-center justify-center gap-2 bg-white text-black hover:bg-zinc-200 active:scale-[0.98] transition-all px-4 py-3.5 rounded-sm font-display font-bold uppercase tracking-wide text-sm"
                >
                    <Phone className="w-4 h-4" />
                    Call
                </a>
            </div>
        </div>
    );
}
